export default function Intro() {
  return (
    <section
      id="positionnement"
      data-testid="intro-section"
      className="relative bg-[#0B132B] text-[#F0ECE1] py-20 sm:py-28 px-6 sm:px-10 lg:px-16"
    >
      <div className="max-w-5xl mx-auto reveal">
        <p className="eyebrow flex items-center mb-8">
          <span className="gold-line" />
          Positionnement
        </p>
        <p className="font-serif font-light text-2xl sm:text-3xl lg:text-4xl leading-[1.35] tracking-tight">
          J'interviens lorsqu'une DSI doit être reprise en main rapidement :
          vacance de poste, crise IT, transformation à risque, gouvernance
          affaiblie ou programme stratégique en dérive.{" "}
          <span className="italic text-[#C8A97E]">
            Mon rôle n'est pas d'ajouter un audit de plus, mais de reprendre le
            pilotage, sécuriser l'exécution et remettre la direction du SI en
            ordre de marche.
          </span>
        </p>
      </div>
    </section>
  );
}
